import { cn } from "@/lib/utils"
import { SpinnerIcon } from "@phosphor-icons/react"

/**
 * Az egyetlen pörgő ikon a rendszerben (a shadcn `spinner`). A méretét a `className`
 * adja (`size-8`, ...), alapból `size-4`, a színét a szövegtől örökli. Gombban a `Button`
 * `loading` propja rakja ki, blokk-szintű, késleltetett állapothoz a `Loading` való.
 */
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <SpinnerIcon
      data-slot="spinner"
      role="status"
      aria-label="Betöltés"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  )
}

export { Spinner }
